const version = '1.3.35' ;

export default version ;